const de = (n, d = 2) =>
  Number(n || 0).toLocaleString("de-DE", {
    minimumFractionDigits: d,
    maximumFractionDigits: d
  });

export const eur = n => (n > 0 && n < 0.005 ? "< 0,01 €" : `${de(n, 2)} €`);

export const num = n => Math.round(Number(n || 0)).toLocaleString("de-DE");

export const pct = n => `${de(n, 1)} %`;

export const tok = n => {
  const value = Number(n || 0);
  if (value >= 1e6) return `${de(value / 1e6, 2)} Mio`;
  if (value >= 1e3) return `${de(value / 1e3, 1)} Tsd`;
  return num(value);
};

export const axis = n => {
  const value = Number(n || 0);
  if (value >= 1e6) return `${de(value / 1e6, 1)} Mio`;
  if (value >= 1e3) return `${de(value / 1e3, 0)} Tsd`;
  return num(value);
};

export const paar = values => {
  const safeValues = Array.isArray(values)
    ? values.map(v => Number(v || 0))
    : [0, 0];
  const max = Math.max(...safeValues, 0);
  const div = max >= 1e6 ? 1e6 : max >= 1e3 ? 1e3 : 1;
  const unit = div === 1e6 ? "Mio" : div === 1e3 ? "Tsd" : "";
  const dec = div === 1 ? 0 : 2;

  return {
    value: safeValues.map(v => de(v / div, dec)).join(" / "),
    unit
  };
};

export const barLabel = n => {
  const value = Number(n || 0);
  if (value <= 0) return "-";
  return de(value, value < 1 ? 3 : 2);
};
